import { Component, Input } from '@angular/core';

/**
 * @usage
 * <rx-skeleton-element width="100%" height="100px"/>
 * 
 * @param testId - The test id to be used for the skeleton element, for automation tests detect if the component is loaded
 * @param width - The width of the skeleton element
 * @param height - The height of the skeleton element
 */
@Component({
  standalone: true,
  selector: 'rx-skeleton-element',
  styleUrls: ['./skeleton-element.component.scss'],
  template: `<div class="skeleton-element" [attr.data-qa]="testId" [style.width]="width" [style.height]="height"></div>`,
})
export class SkeletonElementComponent {
  @Input() testId: string = 'test-loading-element';
  @Input() width: string = '100%';
  @Input() height: string = '24px';
}
